import { get, post, patch, del } from "../../helpers/apiWrapper";

const API_BASE_URL = "https://jsonplaceholder.typicode.com";

// Function to get a list of network locations

export const getUserDetail = async () => {
  // data: for request body
  // params: for request parameters
  // const config = {
  //   params: params,
  //   data:data
  // };

  const data = {
    username:'hireOquick',
    color:{
      primary:'#5C2D91'
    }
  }

  // return await get(`${API_BASE_URL}/users`);
  return await data;
};